<template>
  <div>
    <header>
      <nav class="eyebrow">
        <div class="container">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a class="nav-link" href="https://www.cookcountyil.gov/">
                Cook County Home
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://www.cookcountyil.gov/agency/environmental-control">
                DES Home
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://edit.cookcountyil.gov/form/webform-4984">
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </nav>
      <nav class="primary" :class="{'warning': !isProduction}">
        <div class="container">
          <button class="navbar-toggler invisible"
                  type="button"
                  data-toggle="collapse"
                  data-target="#toggleable-navbar"
                  aria-controls="toggleable-navbar"
                  aria-expanded="false"
                  aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <a href="https://www.cookcountyil.gov/" class="logo-link">
            <img src="./assets/logo.png" alt="Cook County Logo" />
            <div class="header-title">
              Cook County
              <br />
              Government
            </div>
          </a>
          <div class="collapse navbar-collapse" id="toggleable-navbar">
            <ul class="navbar-nav my-0 ml-auto">
              <li class="nav-item invisible">
                <router-link
                  :to="{name: 'PermitLanding', params: {projectType: 'asbestos'}}"
                  class="nav-link">
                  Asbestos
                </router-link>
              </li>
              <li class="nav-item invisible">
                <router-link
                  :to="{name: 'PermitLanding', params: {projectType: 'demolition'}}"
                  class="nav-link">
                  Demolition
                </router-link>
              </li>
              <li class="nav-item invisible">
                <router-link
                  :to="{name: 'ContractorLanding'}"
                  class="nav-link">
                  Contractor Registration
                </router-link>
              </li>
              <li class="nav-item invisible">
                <router-link
                  :to="{name: 'OpAndMainSelect'}"
                  class="nav-link">
                  O&M
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div class="sub-header">
        Department of Environment &amp; Sustainability
      </div>
    </header>

    <div class="container mt-4">
      <transition name="def">
        <router-view />
      </transition>
    </div>
    <footer>
      <ul>
        <li><a href="https://www.cookcountyil.gov/privacy-policy/">Privacy Policy</a></li>
        <li><a href="https://www.cookcountyil.gov/terms-use/">Terms of Use</a></li>
      </ul>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    isProduction() {
      return window.location.hostname === 'espay.cookcountyil.gov';
    },
  },
};
</script>

<style scoped lang="scss">
  .def-enter {
    max-height: 0;
  }

  .def-enter-active {
    animation: def-in 0.5s;
  }

  .def-leave, .def-leave-active, .def-leave-to {
    display: none;
  }

  @keyframes def-in {
    0% {
      transform: translateX(150px);
      opacity: 0.4;
    }

    75% {
      transform: translateX(-10px);
    }

    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
</style>
